import { Services, joinURLPath } from '@sigma-frontend-libs/commons'
import { TaskTypes } from '@sigmasms/shared-types'

import { globalErrorHandler, permissionPresets, request } from '@/utils'

import render from './render'

export default {
  name: 'TaskMenuButton',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      showMenu: false,
      showSourceDataDialog: false,
      showEventsHistoryDialog: false
    }
  },

  computed: {
    canGetHistoryAsAdmin() {
      return this.checkPermissions(`advanced.${Services.eventsHistory}.get`)
    },
    canGetTasksAsMeUp() {
      return this.checkPermissions(`advanced.${Services.tasks}.remove`, permissionPresets.meUp)
    },
    canRemoveTasksAsAdmin() {
      return this.checkPermissions(`advanced.${Services.tasks}.update`)
    },

    hasAnalytics() {
      const groupId = this.value.data?.sending?.groupId
      if (this.value.type === TaskTypes['sendings:bulk'] && groupId) {
        return true
      }

      return false
    },

    analyticsTo() {
      if (this.hasAnalytics) {
        const $lt = new Date(this.value.updatedAt)
        $lt.setMinutes($lt.getMinutes() + 1)

        return {
          name: Services.sendings,
          query: {
            groupId: this.value.data.sending.groupId,
            currentTab: 'outgoing',
            createdAt: JSON.stringify({
              $gt: this.value.createdAt,
              $lt: $lt.toISOString()
            })
          }
        }
      }
    }
  },

  watch: {
    showMenu(value) {
      this.$emit('menu', value)
    }
  },

  methods: {
    async remove() {
      try {
        await request.remove(joinURLPath(Services.tasks, this.value.id))
        this.addSnackbar({
          text: this.getTranslate(`${Services.tasks}.snackbars.removed`),
          type: 'error'
        })
      } catch (error) {
        globalErrorHandler(error)
      }
    }
  },

  render
}
